import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { NumeralIntegrationConfig } from './numeral.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

const enableNumeralIntegration = async (): Promise<{ success: boolean }> => {
  const result = await dashboardv99990101Client.putEnabledTaxIntegration({
    taxIntegrationProvider: 'NUMERAL'
  })
  return { success: !result.error }
}

export const numeralConfigurationMutator = async (
  data: NumeralIntegrationConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  if (data.apiKey) {
    const credentialsResult =
      await dashboardv99990101Client.postStoreNumeralCredentials({
        apiKey: data.apiKey
      })

    if (credentialsResult.error) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }

    const enableResult = await enableNumeralIntegration()
    if (!enableResult.success) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }
  }

  return { success: true, error: null }
}
